var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Icon from '../Icon/Icon';
import { IconName } from '../Icon/Icon.enum';
import { BaseButtonType } from './Button.enum';
import { handleButtonColors, handleButtonRound, handleButtonSize } from './button.helpers';
const baseButtonStyles = css `
  display: grid;
  align-content: center;
  justify-content: center;
  grid-auto-flow: column;
  align-items: center;
  grid-column-gap: 10px;
  text-decoration: none;
  cursor: pointer;
  transition: 300ms background linear;
  box-shadow: ${(props) => props.variant !== BaseButtonType.DISABLED ? props.theme.shadows.small : 'none'};
  font-weight: 600;
  border: ${(props) => props.variant === BaseButtonType.INVERTED
    ? `1px solid ${props.theme.colors.interactivePrimary01}`
    : 'none'};
  margin: ${(props) => props.margin || '0'};
  ${({ size, theme }) => handleButtonSize(size, theme)}
  ${({ variant, theme }) => handleButtonColors(variant, theme)}
  ${({ round, theme }) => handleButtonRound(round, theme)}
`;
const BaseButton = styled.button `
  ${baseButtonStyles}
`;
const BaseButtonLink = styled.a `
  ${baseButtonStyles}
`;
const Button = (_a) => {
    var { size, margin, variant, round, children, href } = _a, delegated = __rest(_a, ["size", "margin", "variant", "round", "children", "href"]);
    if (href) {
        return (_jsxs(BaseButtonLink, Object.assign({ href: href, margin: margin, round: round, size: size, variant: variant }, delegated, { children: [round && _jsx(Icon, { name: IconName.CHEVRON_DOWN }, void 0), children] }), void 0));
    }
    return (_jsxs(BaseButton, Object.assign({ disabled: variant === BaseButtonType.DISABLED, margin: margin, round: round, size: size, variant: variant }, delegated, { children: [round && _jsx(Icon, { name: IconName.CHEVRON_DOWN }, void 0), children] }), void 0));
};
export default Button;
//# sourceMappingURL=Button.js.map